module.exports = __webpack_public_path__ + "static/media/like.5e6ddacd.png";